export const frontmatter = {
    "draft": true,
    "title": "Primeros pasos",
    "sidebar_group": "quickstart",
    "sidebar_group_label": "Inicio rápido",
    "sidebar_label": "Primeros pasos",
    "sidebar_order": 2
}

export const toc = []